import { FormattedMessage, defineMessage, useIntl } from 'react-intl';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getJSON } from '@folklore/fetch';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { isTextFilled, isHeaderFilled, isFooterFilled, getFooterProps, getStyleFromColor, isValidUrl } from '@micromag/core/utils';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import { ScreenElement, Empty, PlaceholderSubtitle, PlaceholderTitle, PlaceholderImage, PlaceholderText } from '@micromag/core/components';
import { useScreenSize, useScreenRenderContext, useViewerWebView, useViewerContext, useViewerInteraction, usePlaybackContext, usePlaybackMediaRef } from '@micromag/core/contexts';
import { useDimensionObserver, useResizeObserver } from '@micromag/core/hooks';
import Background from '@micromag/element-background';
import Container from '@micromag/element-container';
import Footer from '@micromag/element-footer';
import Header from '@micromag/element-header';
import Heading from '@micromag/element-heading';
import Text from '@micromag/element-text';
import UrbaniaAuthor from '@micromag/element-urbania-author';
import Visual from '@micromag/element-visual';
import { useSpring, easings, animated } from '@react-spring/web';
import { useGesture } from '@use-gesture/react';
import isString from 'lodash/isString';
import queryString from 'query-string';
import Layout from '@micromag/element-layout';

var propTypes$4 = {
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string
};
var defaultProps$4 = {
  color: 'currentColor',
  strokeWidth: 3,
  className: null
};
var Arrow = function Arrow(_ref) {
  var color = _ref.color,
    strokeWidth = _ref.strokeWidth,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0",
    y: "0px",
    width: "48.53px",
    height: "12.38px",
    viewBox: "0 0 48.53 12.38",
    className: className,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    fill: "none",
    stroke: color,
    strokeWidth: "".concat(strokeWidth, "px"),
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "M1.5,10.88L24.26,1.5l22.77,9.38"
  })));
};
Arrow.propTypes = propTypes$4;
Arrow.defaultProps = defaultProps$4;

var propTypes$3 = {
  color: PropTypes.string,
  className: PropTypes.string
};
var defaultProps$3 = {
  color: '#222',
  className: null
};
var WatchIcon = function WatchIcon(_ref) {
  var color = _ref.color,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0",
    y: "0px",
    width: "17.76px",
    height: "17.76px",
    viewBox: "0 0 17.76 17.76",
    className: className,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M8.34,0h1.08s.06,.02,.1,.02c.89,.07,1.77,.26,2.6,.59,1.9,.74,3.48,2.11,4.48,3.88,.5,.88,.85,1.84,1.02,2.84,.06,.34,.1,.69,.14,1.04v1.05s-.02,.1-.03,.15c-.2,2.62-1.55,5.01-3.69,6.53-1.17,.85-2.54,1.39-3.98,1.57l-.64,.09h-1.08s-.1-.02-.15-.03c-.94-.07-1.87-.3-2.74-.66C2.55,15.85,.51,13.18,.08,10.06c-.03-.21-.06-.43-.08-.64v-1.08c0-.06,.02-.11,.03-.17C.21,5.84,1.32,3.67,3.1,2.15,4.4,1.02,6,.3,7.71,.08l.63-.08Zm7.94,8.71c-.09-4.09-3.48-7.32-7.57-7.23-4.09,.09-7.32,3.48-7.23,7.57,.09,4.09,3.48,7.32,7.57,7.23,.04,0,.07,0,.11,0,4.04-.16,7.2-3.53,7.12-7.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M7.42,8.89v-2.61c-.02-.2,.09-.4,.28-.48,.15-.06,.32-.04,.44,.06,.39,.28,.78,.56,1.17,.85,.82,.59,1.63,1.19,2.45,1.78,.22,.11,.3,.38,.19,.59-.04,.08-.11,.15-.19,.19-.6,.45-1.21,.89-1.82,1.33-.59,.43-1.18,.86-1.78,1.29-.16,.17-.43,.17-.6,0-.02-.02-.03-.03-.04-.05-.07-.11-.1-.24-.1-.37,0-.86,0-1.72,0-2.58h0Z"
  })));
};
WatchIcon.propTypes = propTypes$3;
WatchIcon.defaultProps = defaultProps$3;

var styles$1 = {"footerContainer":"micromag-screen-urbania-article-urbania-base-article-footerContainer","video":"micromag-screen-urbania-article-urbania-base-article-video","empty":"micromag-screen-urbania-article-urbania-base-article-empty","container":"micromag-screen-urbania-article-urbania-base-article-container","isVideo":"micromag-screen-urbania-article-urbania-base-article-isVideo","visual":"micromag-screen-urbania-article-urbania-base-article-visual","disabled":"micromag-screen-urbania-article-urbania-base-article-disabled","hidden":"micromag-screen-urbania-article-urbania-base-article-hidden","placeholder":"micromag-screen-urbania-article-urbania-base-article-placeholder","content":"micromag-screen-urbania-article-urbania-base-article-content","isPlaceholder":"micromag-screen-urbania-article-urbania-base-article-isPlaceholder","articleContent":"micromag-screen-urbania-article-urbania-base-article-articleContent","title":"micromag-screen-urbania-article-urbania-base-article-title","description":"micromag-screen-urbania-article-urbania-base-article-description","sponsors":"micromag-screen-urbania-article-urbania-base-article-sponsors","callToAction":"micromag-screen-urbania-article-urbania-base-article-callToAction","emptyContainer":"micromag-screen-urbania-article-urbania-base-article-emptyContainer","small":"micromag-screen-urbania-article-urbania-base-article-small","background":"micromag-screen-urbania-article-urbania-base-article-background","overTitle":"micromag-screen-urbania-article-urbania-base-article-overTitle","authors":"micromag-screen-urbania-article-urbania-base-article-authors","lede":"micromag-screen-urbania-article-urbania-base-article-lede","isAboveDescription":"micromag-screen-urbania-article-urbania-base-article-isAboveDescription","sponsor":"micromag-screen-urbania-article-urbania-base-article-sponsor","quatre95":"micromag-screen-urbania-article-urbania-base-article-quatre95","author":"micromag-screen-urbania-article-urbania-base-article-author","urbania":"micromag-screen-urbania-article-urbania-base-article-urbania","dehors":"micromag-screen-urbania-article-urbania-base-article-dehors","universities":"micromag-screen-urbania-article-urbania-base-article-universities","footer":"micromag-screen-urbania-article-urbania-base-article-footer","arrow":"micromag-screen-urbania-article-urbania-base-article-arrow","icon":"micromag-screen-urbania-article-urbania-base-article-icon","button":"micromag-screen-urbania-article-urbania-base-article-button","mediaControls":"micromag-screen-urbania-article-urbania-base-article-mediaControls","header":"micromag-screen-urbania-article-urbania-base-article-header","bottom":"micromag-screen-urbania-article-urbania-base-article-bottom","visible":"micromag-screen-urbania-article-urbania-base-article-visible","withGradient":"micromag-screen-urbania-article-urbania-base-article-withGradient","image":"micromag-screen-urbania-article-urbania-base-article-image","isCurrent":"micromag-screen-urbania-article-urbania-base-article-isCurrent","slowZoom":"micromag-screen-urbania-article-urbania-base-article-slowZoom","img":"micromag-screen-urbania-article-urbania-base-article-img"};

var _excluded$1 = ["callToAction"];
var propTypes$2 = {
  hasArticle: PropTypes.bool,
  type: PropTypes.oneOf(['article', 'video']),
  image: PropTypes$1.visualElement,
  title: PropTypes$1.headingElement,
  description: PropTypes$1.textElement,
  overTitle: PropTypes$1.headingElement,
  author: PropTypes$1.authorElement,
  sponsors: PropTypes.arrayOf(PropTypes.shape({})),
  sponsorPrefix: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  sponsorColor: PropTypes$1.color,
  site: PropTypes.string,
  header: PropTypes$1.header,
  footer: PropTypes$1.footer,
  background: PropTypes$1.backgroundElement,
  current: PropTypes.bool,
  preload: PropTypes.bool,
  spacing: PropTypes.number,
  className: PropTypes.string
};
var defaultProps$2 = {
  hasArticle: false,
  type: null,
  image: null,
  title: null,
  description: null,
  overTitle: null,
  author: null,
  sponsors: null,
  sponsorPrefix: null,
  sponsorColor: null,
  site: null,
  header: null,
  footer: null,
  background: null,
  current: true,
  preload: true,
  spacing: 20,
  className: null
};
var UrbaniaArticle = function UrbaniaArticle(_ref) {
  var hasArticle = _ref.hasArticle,
    type = _ref.type,
    image = _ref.image,
    title = _ref.title,
    description = _ref.description,
    overTitle = _ref.overTitle,
    author = _ref.author,
    sponsors = _ref.sponsors,
    sponsorPrefix = _ref.sponsorPrefix,
    sponsorColor = _ref.sponsorColor,
    site = _ref.site,
    header = _ref.header,
    footer = _ref.footer,
    background = _ref.background,
    current = _ref.current,
    preload = _ref.preload,
    spacing = _ref.spacing,
    className = _ref.className;
  var _useScreenSize = useScreenSize(),
    width = _useScreenSize.width,
    height = _useScreenSize.height,
    resolution = _useScreenSize.resolution;
  var _useScreenRenderConte = useScreenRenderContext(),
    isView = _useScreenRenderConte.isView,
    isPreview = _useScreenRenderConte.isPreview,
    isPlaceholder = _useScreenRenderConte.isPlaceholder,
    isEdit = _useScreenRenderConte.isEdit,
    isStatic = _useScreenRenderConte.isStatic,
    isCapture = _useScreenRenderConte.isCapture;
  var _ref2 = background || {},
    _ref2$color = _ref2.color,
    backgroundColor = _ref2$color === void 0 ? null : _ref2$color;
  var _useViewerWebView = useViewerWebView(),
    openedWebView = _useViewerWebView.opened,
    openWebView = _useViewerWebView.open;
  var _useViewerContext = useViewerContext(),
    viewerBottomSidesWidth = _useViewerContext.bottomSidesWidth,
    viewerTopHeight = _useViewerContext.topHeight;
  var _useViewerInteraction = useViewerInteraction(),
    enableInteraction = _useViewerInteraction.enableInteraction,
    disableInteraction = _useViewerInteraction.disableInteraction;
  var _usePlaybackContext = usePlaybackContext(),
    muted = _usePlaybackContext.muted,
    playing = _usePlaybackContext.playing;
  var mediaRef = usePlaybackMediaRef(current);
  var _useDimensionObserver = useDimensionObserver(),
    contentRef = _useDimensionObserver.ref,
    contentRect = _useDimensionObserver.entry.contentRect,
    contentHeight = _useDimensionObserver.height;
  var _ref3 = contentRect || {},
    contentTop = _ref3.top;
  var _useMemo = useMemo(function () {
      // const defaultImageHeight = width * 0.8;
      var difference = height - contentHeight - contentTop + 1;
      return {
        imageHeight: difference
      };
    }, [contentTop, contentHeight, width, height]),
    _useMemo$minContentHe = _useMemo.minContentHeight,
    minContentHeight = _useMemo$minContentHe === void 0 ? null : _useMemo$minContentHe;
  var isVideo = type === 'video';
  var hasOverTitle = isTextFilled(overTitle);
  var hasTitle = isTextFilled(title);
  var hasDescription = isTextFilled(description);
  var hasSponsor = (sponsors || []).length > 0 && isTextFilled(sponsors[0]);
  var _ref4 = author || {},
    authorFullName = _ref4.name;
  var hasAuthor = isTextFilled(authorFullName);
  var _ref5 = image || {},
    _ref5$url = _ref5.url,
    url = _ref5$url === void 0 ? null : _ref5$url,
    _ref5$type = _ref5.type,
    imageType = _ref5$type === void 0 ? null : _ref5$type;
  var hasImage = url !== null;
  var hasHeader = isHeaderFilled(header);
  var hasFooter = isFooterFilled(footer) || hasArticle;
  var footerCta = {
    buttonClassName: styles$1.button,
    labelClassName: styles$1.label,
    arrowClassName: styles$1.arrow,
    arrow: /*#__PURE__*/React.createElement(Arrow, null),
    icon: type === 'video' ? /*#__PURE__*/React.createElement(WatchIcon, {
      className: styles$1.icon
    }) : null
  };
  var _ref6 = footer || {},
    _ref6$callToAction = _ref6.callToAction,
    callToAction = _ref6$callToAction === void 0 ? null : _ref6$callToAction,
    otherFooterProps = _objectWithoutProperties(_ref6, _excluded$1);
  var footerProps = getFooterProps(_objectSpread(_objectSpread({}, otherFooterProps), {}, {
    callToAction: _objectSpread(_objectSpread({}, callToAction), footerCta)
  }), {
    isView: isView,
    current: current,
    openWebView: openWebView,
    isPreview: isPreview,
    animationDisabled: isPreview,
    focusable: current && isView,
    enableInteraction: enableInteraction,
    disableInteraction: disableInteraction
  });
  var _ref7 = background || {},
    _ref7$video = _ref7.video,
    backgroundVideo = _ref7$video === void 0 ? null : _ref7$video;
  var hasVideoBackground = backgroundVideo !== null;
  var mediaShouldLoad = current || preload;
  var finalPlaying = playing && current;
  var backgroundPlaying = current && !openedWebView && (isView || isEdit);
  var items = [/*#__PURE__*/React.createElement(ScreenElement, {
    key: "overTitle",
    placeholder: /*#__PURE__*/React.createElement(PlaceholderSubtitle, {
      className: styles$1.placeholder
    }),
    empty: /*#__PURE__*/React.createElement("div", {
      className: classNames([styles$1.emptyContainer, styles$1.small])
    }, /*#__PURE__*/React.createElement(Empty, {
      className: styles$1.empty
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "pRzSQ7",
      defaultMessage: [{
        "type": 0,
        "value": "Overtitle"
      }]
    }))),
    isEmpty: !hasOverTitle
  }, hasOverTitle ? /*#__PURE__*/React.createElement(Heading, Object.assign({
    className: classNames([styles$1.overTitle])
  }, overTitle)) : null), /*#__PURE__*/React.createElement(ScreenElement, {
    key: "title",
    placeholder: /*#__PURE__*/React.createElement(PlaceholderTitle, {
      className: styles$1.placeholder
    }),
    empty: /*#__PURE__*/React.createElement("div", {
      className: styles$1.emptyContainer
    }, /*#__PURE__*/React.createElement(Empty, {
      className: styles$1.empty
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "2ZOPe+",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    }))),
    isEmpty: !hasTitle
  }, hasTitle ? /*#__PURE__*/React.createElement(Heading, Object.assign({
    className: classNames([styles$1.title])
  }, title)) : null), /*#__PURE__*/React.createElement(ScreenElement, {
    key: "authors",
    empty: /*#__PURE__*/React.createElement("div", {
      className: styles$1.emptyContainer
    }, /*#__PURE__*/React.createElement(Empty, {
      className: styles$1.empty
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "6jX5Tb",
      defaultMessage: [{
        "type": 0,
        "value": "Authors"
      }]
    }))),
    isEmpty: !hasAuthor
  }, hasAuthor ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$1.authors, _defineProperty({}, styles$1.isAboveDescription, hasDescription)])
  }, /*#__PURE__*/React.createElement(UrbaniaAuthor, {
    author: author,
    shouldLoad: mediaShouldLoad
  })) : null), /*#__PURE__*/React.createElement(ScreenElement, {
    key: "description",
    empty: /*#__PURE__*/React.createElement("div", {
      className: styles$1.emptyContainer
    }, /*#__PURE__*/React.createElement(Empty, {
      className: styles$1.empty
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "zl6zsZ",
      defaultMessage: [{
        "type": 0,
        "value": "Lede"
      }]
    }))),
    isEmpty: !hasDescription && !hasArticle
  }, hasDescription ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$1.description])
  }, /*#__PURE__*/React.createElement(Text, Object.assign({
    className: classNames([styles$1.lede])
  }, description))) : null), /*#__PURE__*/React.createElement(ScreenElement, {
    key: "sponsors",
    empty: /*#__PURE__*/React.createElement("div", {
      className: classNames([styles$1.emptyContainer, styles$1.small])
    }, /*#__PURE__*/React.createElement(Empty, {
      className: styles$1.empty
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "zGIcdn",
      defaultMessage: [{
        "type": 0,
        "value": "Sponsors"
      }]
    }))),
    isEmpty: !hasSponsor && !hasArticle
  }, hasSponsor ? /*#__PURE__*/React.createElement("div", {
    className: styles$1.sponsors,
    style: _objectSpread({}, getStyleFromColor(sponsorColor))
  }, sponsors.map(function () {
    var sponsor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var _ref9 = sponsor || {},
      _ref9$body = _ref9.body,
      body = _ref9$body === void 0 ? '' : _ref9$body;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: body
    }, sponsorPrefix !== null ? /*#__PURE__*/React.createElement("span", {
      className: styles$1.sponsor
    }, sponsorPrefix) : null, /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement(Heading, Object.assign({
      className: styles$1.sponsor,
      size: "6"
    }, sponsor)));
  })) : null)].filter(function (it) {
    return it !== null;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$1.container, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, className, className !== null), styles$1.isCurrent, current), styles$1.isVideo, isVideo), styles$1.hasVideoBackground, hasVideoBackground), styles$1.isPlaceholder, isPlaceholder)]),
    "data-screen-ready": isStatic || isCapture
  }, /*#__PURE__*/React.createElement(Background, {
    className: styles$1.background,
    background: background,
    width: width,
    height: height,
    resolution: resolution,
    playing: backgroundPlaying,
    muted: muted,
    shouldLoad: mediaShouldLoad,
    mediaRef: imageType !== 'video' && hasVideoBackground ? mediaRef : null,
    withoutVideo: isPreview
  }), /*#__PURE__*/React.createElement(Container, {
    className: styles$1.content,
    width: width,
    height: height
  }, !isPlaceholder && hasHeader ? /*#__PURE__*/React.createElement("div", {
    key: "header",
    className: styles$1.header,
    style: {
      paddingTop: spacing / 2,
      paddingLeft: spacing,
      paddingRight: spacing,
      transform: !isPreview ? "translate(0, ".concat(viewerTopHeight, "px)") : null
    }
  }, /*#__PURE__*/React.createElement(Header, header)) : null, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$1.articleContent, _defineProperty({}, styles$1["".concat(site)], site !== null)]),
    style: _objectSpread({
      paddingTop: spacing,
      minHeight: minContentHeight
    }, !isVideo ? getStyleFromColor(backgroundColor, 'backgroundColor') : null),
    ref: contentRef
  }, items), /*#__PURE__*/React.createElement("div", {
    className: styles$1.visual
  }, /*#__PURE__*/React.createElement(ScreenElement, {
    key: "image",
    placeholder: /*#__PURE__*/React.createElement(PlaceholderImage, {
      className: styles$1.placeholder
    }),
    empty: /*#__PURE__*/React.createElement("div", {
      className: styles$1.emptyContainer
    }, /*#__PURE__*/React.createElement(Empty, {
      className: styles$1.empty
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "ebsPd4",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }))),
    isEmpty: !hasImage && !hasArticle
  }, hasImage && !isVideo ? /*#__PURE__*/React.createElement(Visual, {
    className: styles$1.image,
    imageClassName: styles$1.img,
    media: image,
    width: width,
    height: height,
    resolution: resolution,
    objectFit: {
      fit: 'cover'
    },
    shouldLoad: mediaShouldLoad
  }) : null, hasImage && isVideo && !hasVideoBackground ? /*#__PURE__*/React.createElement(Visual, {
    className: styles$1.video,
    media: image,
    width: width,
    height: height,
    resolution: resolution,
    objectFit: {
      fit: 'cover'
    },
    shouldLoad: mediaShouldLoad,
    playing: finalPlaying,
    muted: muted,
    withoutVideo: isPreview,
    mediaRef: mediaRef,
    autoPlay: true
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: styles$1.footerContainer
  }, !isPlaceholder && hasFooter ? /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: spacing,
      paddingLeft: Math.max(0, viewerBottomSidesWidth - spacing),
      paddingRight: Math.max(0, viewerBottomSidesWidth - spacing)
    },
    className: styles$1.footer
  }, /*#__PURE__*/React.createElement(Footer, footerProps)) : null)));
};
UrbaniaArticle.propTypes = propTypes$2;
UrbaniaArticle.defaultProps = defaultProps$2;

var _excluded = ["component", "title", "articleType", "overTitle", "sponsorLabel", "author", "image", "header", "footer", "url", "article"];
var propTypes$1 = {
  component: PropTypes.elementType,
  // theme: PropTypes.string,
  title: PropTypes$1.headingElement,
  articleType: PropTypes.string,
  overTitle: PropTypes.shape({
    body: PropTypes.string
  }),
  sponsorLabel: PropTypes.shape({
    body: PropTypes.string
  }),
  author: PropTypes$1.authorElement,
  image: PropTypes$1.image,
  header: PropTypes$1.header,
  footer: PropTypes$1.footer,
  url: PropTypes.string,
  article: PropTypes.shape({
    type: PropTypes.string
  })
};
var defaultProps$1 = {
  component: UrbaniaArticle,
  // theme: null,
  title: null,
  articleType: null,
  overTitle: null,
  sponsorLabel: null,
  author: null,
  image: null,
  header: null,
  footer: null,
  url: null,
  article: null
};
var UrbaniaLoader = function UrbaniaLoader(_ref) {
  var Component = _ref.component,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$articleType = _ref.articleType,
    articleType = _ref$articleType === void 0 ? null : _ref$articleType,
    _ref$overTitle = _ref.overTitle,
    overTitle = _ref$overTitle === void 0 ? null : _ref$overTitle,
    _ref$sponsorLabel = _ref.sponsorLabel,
    sponsorLabel = _ref$sponsorLabel === void 0 ? null : _ref$sponsorLabel,
    _ref$author = _ref.author,
    author = _ref$author === void 0 ? null : _ref$author,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$header = _ref.header,
    header = _ref$header === void 0 ? null : _ref$header,
    _ref$footer = _ref.footer,
    footer = _ref$footer === void 0 ? null : _ref$footer,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    initialArticle = _ref.article,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(initialArticle),
    _useState2 = _slicedToArray(_useState, 2),
    article = _useState2[0],
    setArticle = _useState2[1];
  var finalUrl = url !== null && isValidUrl(url) ? url.replace(/^https?:\/\/([^.]+\.)?urbania\.(ca|ƒr)\//, 'https://urbania.$2/') : null;
  useEffect(function () {
    if (finalUrl !== null) {
      getJSON("https://api.urbania.ca/documents?uri=".concat(finalUrl), {
        mode: 'cors'
      }).then(function (art) {
        // console.log('art loaded', art);
        setArticle(art || null);
      })["catch"](function (e) {
        // console.log('art error', e);
        setArticle(null);
      });
    }
  }, [url, finalUrl, setArticle]);
  var values = useMemo(function () {
    var _ref2 = image || {},
      _ref2$url = _ref2.url,
      imageUrl = _ref2$url === void 0 ? null : _ref2$url;
    var _ref3 = footer || {},
      _ref3$callToAction = _ref3.callToAction,
      callToAction = _ref3$callToAction === void 0 ? null : _ref3$callToAction;
    var _ref4 = callToAction || {},
      _ref4$url = _ref4.url,
      ctaUrl = _ref4$url === void 0 ? null : _ref4$url;

    // Straight from article
    var _ref5 = article || {},
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? null : _ref5$type,
      _ref5$title = _ref5.title,
      articleTitle = _ref5$title === void 0 ? null : _ref5$title,
      _ref5$image = _ref5.image,
      articleImage = _ref5$image === void 0 ? null : _ref5$image,
      _ref5$metadata = _ref5.metadata,
      metadata = _ref5$metadata === void 0 ? {} : _ref5$metadata;
    var hasArticle = article !== null;
    var _ref6 = metadata || {},
      _ref6$authors = _ref6.authors,
      authors = _ref6$authors === void 0 ? [] : _ref6$authors,
      _ref6$sponsors = _ref6.sponsors,
      sponsors = _ref6$sponsors === void 0 ? [] : _ref6$sponsors,
      _ref6$brands = _ref6.brands,
      brands = _ref6$brands === void 0 ? [] : _ref6$brands;
    var _ref7 = authors || [],
      _ref8 = _slicedToArray(_ref7, 1),
      _ref8$ = _ref8[0],
      creditAuthor = _ref8$ === void 0 ? null : _ref8$;
    var _ref9 = brands || [],
      _ref0 = _slicedToArray(_ref9, 1),
      _ref0$ = _ref0[0],
      _ref0$2 = _ref0$ === void 0 ? {} : _ref0$,
      _ref0$2$handle = _ref0$2.handle,
      site = _ref0$2$handle === void 0 ? null : _ref0$2$handle;
    var _ref1 = articleImage || {},
      _ref1$sizes = _ref1.sizes,
      sizes = _ref1$sizes === void 0 ? {} : _ref1$sizes;
    var _ref10 = sizes || {},
      _ref10$medium = _ref10.medium,
      medium = _ref10$medium === void 0 ? {} : _ref10$medium,
      _ref10$large = _ref10.large,
      large = _ref10$large === void 0 ? {} : _ref10$large;
    var _ref11 = creditAuthor || {},
      _ref11$name = _ref11.name,
      authorName = _ref11$name === void 0 ? null : _ref11$name,
      _ref11$image = _ref11.image,
      authorImage = _ref11$image === void 0 ? null : _ref11$image;
    var hasCreditAuthorName = authorName !== null && authorName !== '';
    var finalArticleAuthor = _objectSpread(_objectSpread({}, hasCreditAuthorName ? {
      name: {
        body: "<p>".concat(authorName, "</p>")
      }
    } : null), authorImage !== null ? {
      image: authorImage
    } : null);

    // Type
    var defaultType = articleType || type;

    // Sponsors
    var defaultSponsor = (sponsors || []).length > 0 ? (sponsors || []).map(function (_ref12) {
      var _ref12$organisation = _ref12.organisation,
        _ref12$organisation2 = _ref12$organisation === void 0 ? {} : _ref12$organisation,
        _ref12$organisation2$ = _ref12$organisation2.name,
        name = _ref12$organisation2$ === void 0 ? null : _ref12$organisation2$;
      return name;
    }).filter(function (name) {
      return name !== null;
    }).join(', ').trim() : null;

    // Content
    var hasTitle = isTextFilled(title);
    var hasOverTitle = isTextFilled(overTitle);
    var hasSponsorProps = isTextFilled(sponsorLabel);
    var hasAuthorProps = author !== null && author.name !== null && isTextFilled(author.name);
    var sponsorPrefix = !hasSponsorProps && defaultSponsor !== null ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "+TPjd4",
      defaultMessage: [{
        "type": 0,
        "value": "Presented by"
      }]
    }) : null;
    return {
      type: defaultType,
      title: hasTitle ? title : _objectSpread(_objectSpread({}, title), {}, {
        body: articleTitle
      }),
      articleTitle: articleTitle,
      overTitle: hasOverTitle ? overTitle : _objectSpread(_objectSpread({}, overTitle), {}, {
        body: 'En vedette'
      }),
      author: _objectSpread(_objectSpread({}, finalArticleAuthor), hasAuthorProps ? author : null),
      sponsors: defaultSponsor !== null && !hasSponsorProps ? [_objectSpread(_objectSpread({}, sponsorLabel), {}, {
        body: "<strong>".concat(defaultSponsor, "</strong>")
      })] : [sponsorLabel],
      sponsorPrefix: sponsorPrefix,
      site: site,
      image: imageUrl !== null && image !== null ? image : _objectSpread(_objectSpread({
        type: 'image'
      }, articleImage), {}, {
        sizes: {
          medium: medium,
          large: large
        }
      }),
      url: finalUrl,
      header: header,
      footer: _objectSpread(_objectSpread({}, footer), {}, {
        callToAction: _objectSpread(_objectSpread(_objectSpread({
          type: 'swipe-up',
          label: defaultType === 'video' ? {
            body: 'Regarder'
          } : {
            body: 'Lire'
          },
          inWebView: true
        }, callToAction), hasArticle ? {
          active: finalUrl !== null
        } : null), {}, {
          url: ctaUrl || finalUrl
        })
      })
    };
  }, [article, url, title, finalUrl, props, articleType, overTitle, sponsorLabel, author, image, header, footer]);
  var _ref13 = values || {},
    _ref13$title = _ref13.title,
    articleTitle = _ref13$title === void 0 ? null : _ref13$title;
  var _ref14 = articleTitle || {},
    _ref14$body = _ref14.body,
    titleBody = _ref14$body === void 0 ? null : _ref14$body;
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, values, {
    hasArticle: titleBody !== null
  }));
};
UrbaniaLoader.propTypes = propTypes$1;
UrbaniaLoader.defaultProps = defaultProps$1;

// import * as transforms from './transforms/index';

var definition = {
  id: 'urbania-article',
  type: 'screen',
  namespaces: ['urbania'],
  group: {
    label: defineMessage({
      id: "oPjl8f",
      defaultMessage: [{
        "type": 0,
        "value": "Urbania"
      }]
    }),
    order: 10
  },
  title: defineMessage({
    id: "nJgzwC",
    defaultMessage: [{
      "type": 0,
      "value": "Urbania article"
    }]
  }),
  component: UrbaniaLoader,
  fields: [{
    name: 'url',
    type: 'url',
    label: defineMessage({
      id: "2pO2Cj",
      defaultMessage: [{
        "type": 0,
        "value": "Url"
      }]
    })
  }, {
    name: 'articleType',
    type: 'select',
    label: defineMessage({
      id: "ppq6CK",
      defaultMessage: [{
        "type": 0,
        "value": "Type"
      }]
    }),
    options: [{
      value: 'article',
      label: defineMessage({
        id: "pE7UhY",
        defaultMessage: [{
          "type": 0,
          "value": "Article"
        }]
      })
    }, {
      value: 'video',
      label: defineMessage({
        id: "J9e9Qb",
        defaultMessage: [{
          "type": 0,
          "value": "Video"
        }]
      })
    }]
  }, {
    name: 'overTitle',
    type: 'heading-element',
    defaultValue: {
      body: 'En vedette'
    },
    label: defineMessage({
      id: "z2I2bJ",
      defaultMessage: [{
        "type": 0,
        "value": "Overtitle"
      }]
    })
  }, {
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "N25iDO",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text-element',
    label: defineMessage({
      id: "cuKSQz",
      defaultMessage: [{
        "type": 0,
        "value": "Lede"
      }]
    })
  }, {
    name: 'author',
    type: 'author-element',
    label: defineMessage({
      id: "73hxYw",
      defaultMessage: [{
        "type": 0,
        "value": "Author"
      }]
    })
  }, {
    name: 'sponsorLabel',
    type: 'heading-element',
    label: defineMessage({
      id: "hzvEim",
      defaultMessage: [{
        "type": 0,
        "value": "Sponsor Label"
      }]
    })
  }, {
    name: 'sponsorColor',
    type: 'color',
    label: defineMessage({
      id: "Qw8cb5",
      defaultMessage: [{
        "type": 0,
        "value": "Sponsor color"
      }]
    })
  }, {
    name: 'image',
    type: 'visual',
    label: defineMessage({
      id: "k+coTi",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'background',
    type: 'background',
    label: defineMessage({
      id: "+MPZRu",
      defaultMessage: [{
        "type": 0,
        "value": "Background"
      }]
    })
  }, {
    name: 'header',
    type: 'header',
    label: defineMessage({
      id: "rhuDxI",
      defaultMessage: [{
        "type": 0,
        "value": "Header"
      }]
    }),
    theme: {
      badge: {
        label: {
          textStyle: 'badge'
        },
        boxStyle: 'badge'
      }
    }
  }, {
    name: 'footer',
    type: 'footer',
    label: defineMessage({
      id: "g4nybp",
      defaultMessage: [{
        "type": 0,
        "value": "Footer"
      }]
    }),
    theme: {
      callToAction: {
        label: {
          textStyle: 'cta'
        },
        boxStyle: 'cta'
      }
    }
  }]
};

var styles = {"container":"micromag-screen-urbania-article-urbania-base-article-card-container","dragHandle":"micromag-screen-urbania-article-urbania-base-article-card-dragHandle","empty":"micromag-screen-urbania-article-urbania-base-article-card-empty","cardContainer":"micromag-screen-urbania-article-urbania-base-article-card-cardContainer","content":"micromag-screen-urbania-article-urbania-base-article-card-content","placeholder":"micromag-screen-urbania-article-urbania-base-article-card-placeholder","background":"micromag-screen-urbania-article-urbania-base-article-card-background","layout":"micromag-screen-urbania-article-urbania-base-article-card-layout","text":"micromag-screen-urbania-article-urbania-base-article-card-text","isPlaceholder":"micromag-screen-urbania-article-urbania-base-article-card-isPlaceholder","card":"micromag-screen-urbania-article-urbania-base-article-card-card","callToAction":"micromag-screen-urbania-article-urbania-base-article-card-callToAction","arrow":"micromag-screen-urbania-article-urbania-base-article-card-arrow","ctaText":"micromag-screen-urbania-article-urbania-base-article-card-ctaText","cardInner":"micromag-screen-urbania-article-urbania-base-article-card-cardInner","pulse":"micromag-screen-urbania-article-urbania-base-article-card-pulse","articlePreview":"micromag-screen-urbania-article-urbania-base-article-card-articlePreview","articlePreviewInner":"micromag-screen-urbania-article-urbania-base-article-card-articlePreviewInner","articleTitle":"micromag-screen-urbania-article-urbania-base-article-card-articleTitle","header":"micromag-screen-urbania-article-urbania-base-article-card-header"};

var propTypes = {
  hasArticle: PropTypes.bool,
  url: PropTypes.string,
  title: PropTypes$1.headingElement,
  author: PropTypes$1.authorElement,
  text: PropTypes$1.textElement,
  image: PropTypes$1.visualElement,
  header: PropTypes$1.header,
  background: PropTypes$1.backgroundElement,
  callToAction: PropTypes$1.textElement,
  current: PropTypes.bool,
  preload: PropTypes.bool,
  spacing: PropTypes.number,
  className: PropTypes.string
};
var defaultProps = {
  hasArticle: false,
  url: null,
  title: null,
  author: null,
  text: null,
  image: null,
  header: null,
  background: null,
  callToAction: null,
  current: true,
  preload: true,
  spacing: 20,
  className: null
};
var UrbaniaArticleCard = function UrbaniaArticleCard(_ref) {
  var hasArticle = _ref.hasArticle,
    url = _ref.url,
    title = _ref.title,
    author = _ref.author,
    text = _ref.text,
    image = _ref.image,
    header = _ref.header,
    background = _ref.background,
    callToAction = _ref.callToAction,
    current = _ref.current,
    preload = _ref.preload,
    spacing = _ref.spacing,
    className = _ref.className;
  var intl = useIntl();
  var finalBackground = background !== null && (typeof background.color !== 'undefined' && background.color !== null || typeof background.image !== 'undefined' && background.image !== null || typeof background.video !== 'undefined' && background.video !== null) ? background : {
    image: image
  };
  var _ref2 = finalBackground || {},
    _ref2$video = _ref2.video,
    backgroundVideo = _ref2$video === void 0 ? null : _ref2$video;
  var isBackgroundVideo = backgroundVideo !== null;
  var _useScreenSize = useScreenSize(),
    width = _useScreenSize.width,
    height = _useScreenSize.height,
    resolution = _useScreenSize.resolution;
  var _useScreenRenderConte = useScreenRenderContext(),
    isView = _useScreenRenderConte.isView,
    isPreview = _useScreenRenderConte.isPreview,
    isPlaceholder = _useScreenRenderConte.isPlaceholder,
    isEdit = _useScreenRenderConte.isEdit,
    isStatic = _useScreenRenderConte.isStatic,
    isCapture = _useScreenRenderConte.isCapture;
  var _useViewerWebView = useViewerWebView(),
    openWebView = _useViewerWebView.open,
    _useViewerWebView$ope = _useViewerWebView.opened,
    webviewOpened = _useViewerWebView$ope === void 0 ? false : _useViewerWebView$ope,
    _useViewerWebView$clo = _useViewerWebView.close,
    closeWebView = _useViewerWebView$clo === void 0 ? null : _useViewerWebView$clo;
  var _useViewerContext = useViewerContext(),
    viewerTopHeight = _useViewerContext.topHeight,
    viewerBottomHeight = _useViewerContext.bottomHeight;
  var _useViewerInteraction = useViewerInteraction(),
    enableInteraction = _useViewerInteraction.enableInteraction,
    disableInteraction = _useViewerInteraction.disableInteraction;
  var _usePlaybackContext = usePlaybackContext(),
    playing = _usePlaybackContext.playing,
    muted = _usePlaybackContext.muted,
    setControls = _usePlaybackContext.setControls,
    setControlsTheme = _usePlaybackContext.setControlsTheme,
    setControlsSuggestPlay = _usePlaybackContext.setControlsSuggestPlay,
    setPlaying = _usePlaybackContext.setPlaying;
  var _ref3 = author || {},
    _ref3$name = _ref3.name,
    authorName = _ref3$name === void 0 ? null : _ref3$name;
  var hasUrl = url !== null && isString(url) && url.length > 0;
  var hasHeader = isHeaderFilled(header);
  var hasText = isTextFilled(text);
  var hasTitle = isTextFilled(title);
  var hasAuthorName = isTextFilled(authorName);
  var hasCta = isTextFilled(callToAction);

  // const isSimple = hasUrl && url.indexOf('simple.urbania.ca') !== -1;
  var finalUrl = useMemo(function () {
    var cleanedUrl = hasUrl ? url.replace(/^https?:\/\/([^.]+\.)?urbania\.(fr|ca)\//, 'https://urbania.$2/') : url;
    var currentQueryString = queryString.parse(cleanedUrl !== null && cleanedUrl.indexOf('?') !== -1 ? cleanedUrl.split('?')[1] : '');
    return cleanedUrl !== null ? "".concat(cleanedUrl.split('?')[0], "?").concat(queryString.stringify(_objectSpread({
      reader: true,
      _ref: 'micromag'
    }, currentQueryString))) : url;
  }, [hasUrl, url]);
  var mediaShouldLoad = current || preload;
  var backgroundPlaying = current && (isView || isEdit);
  var mediaRef = usePlaybackMediaRef(current && !webviewOpened);

  // card animations
  var withCardAnimation = !isPlaceholder && !isPreview && !isStatic;
  var slideInDelay = withCardAnimation && isBackgroundVideo && backgroundPlaying;
  var withCardBounce = withCardAnimation && current && !webviewOpened;
  useEffect(function () {
    if (!current) {
      return function () {};
    }
    setControlsTheme({
      seekBarOnly: true
    });
    if (isBackgroundVideo && !webviewOpened) {
      setControls(true);
    } else {
      setControls(false);
    }
    return function () {
      if (isBackgroundVideo && !webviewOpened) {
        setControls(false);
      }
    };
  }, [current, setControls, isBackgroundVideo, webviewOpened, setControls, setControlsTheme]);
  var toggleCard = useCallback(function () {
    var newOpened = !webviewOpened;
    if (newOpened) {
      openWebView(finalUrl);
      disableInteraction();
    } else {
      enableInteraction();
    }
  }, [webviewOpened, disableInteraction, enableInteraction, openWebView, finalUrl]);
  var bindGesture = useGesture({
    onDrag: function onDrag(_ref4) {
      var _ref4$movement = _slicedToArray(_ref4.movement, 2),
        my = _ref4$movement[1];
      if (!webviewOpened && my < 0 || webviewOpened && my > 0) {
        toggleCard();
      }
    },
    onWheel: function onWheel(_ref5) {
      var _ref5$movement = _slicedToArray(_ref5.movement, 2),
        my = _ref5$movement[1];
      if (!webviewOpened && my > 0 || webviewOpened && my < 0) {
        toggleCard();
      }
    }
  }, {
    drag: {
      axis: 'y',
      filterTaps: true,
      preventDefault: true
    },
    wheel: {
      axis: 'y'
    }
  });
  var _useResizeObserver = useResizeObserver({
      disabled: !webviewOpened
    }),
    articlePreviewRef = _useResizeObserver.ref,
    _useResizeObserver$en = _useResizeObserver.entry.contentRect,
    articlePreviewContentRect = _useResizeObserver$en === void 0 ? null : _useResizeObserver$en;
  var _ref6 = articlePreviewContentRect || {},
    _ref6$height = _ref6.height,
    articlePreviewHeight = _ref6$height === void 0 ? 0 : _ref6$height;

  // Think about this
  var minimumVisibility = 20;
  var y = 100;
  if (current) {
    y = 100 - Math.max(articlePreviewHeight / height * 100, minimumVisibility);
  }
  var springStyle = useSpring({
    from: {
      y: isPreview ? y : 100
    },
    to: {
      y: y
    },
    delay: slideInDelay ? 1500 : 0,
    config: {
      easing: easings.easeInOutSine,
      duration: y === 100 ? 1000 : 400
    }
  });
  useEffect(function () {
    if (!current && closeWebView !== null) {
      closeWebView();
    }
  }, [current, closeWebView]);
  var onPlayError = useCallback(function () {
    if (isView && playing && current && isBackgroundVideo) {
      setPlaying(false);
      setControlsSuggestPlay(true);
    }
  }, [isView, current, playing, isBackgroundVideo, setPlaying, setControlsSuggestPlay]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty(_defineProperty({}, className, className !== null), styles.isCurrent, current), styles.isPlaceholder, isPlaceholder)]),
    "data-screen-ready": isStatic || isCapture
  }, /*#__PURE__*/React.createElement(Background, {
    className: styles.background,
    background: finalBackground,
    width: width,
    height: height,
    resolution: resolution,
    playing: backgroundPlaying && !webviewOpened,
    muted: muted,
    mediaRef: mediaRef,
    onPlayError: onPlayError,
    shouldLoad: mediaShouldLoad,
    withoutVideo: isPreview
  }), /*#__PURE__*/React.createElement(Container, {
    className: styles.content,
    width: width,
    height: height
  }, !isPlaceholder && hasHeader ? /*#__PURE__*/React.createElement("div", {
    key: "header",
    className: styles.header,
    style: {
      paddingTop: spacing / 2,
      paddingLeft: spacing,
      paddingRight: spacing,
      transform: !isPreview ? "translate(0, ".concat(viewerTopHeight, "px)") : null
    }
  }, /*#__PURE__*/React.createElement(Header, header)) : null, /*#__PURE__*/React.createElement(Layout, {
    className: styles.layout,
    height: height * 0.65
  }, /*#__PURE__*/React.createElement(ScreenElement, {
    key: "text",
    empty: /*#__PURE__*/React.createElement(Empty, {
      className: styles.emptyText
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "z4CiV1",
      defaultMessage: [{
        "type": 0,
        "value": "Text"
      }]
    })),
    placeholder: /*#__PURE__*/React.createElement(PlaceholderText, {
      className: styles.placeholderText
    })
  }, hasText ? /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles.text
  }, text)) : null)), /*#__PURE__*/React.createElement(Container, {
    className: classNames([styles.cardContainer, _defineProperty({}, styles.isPlaceholder, isPlaceholder)])
  }, /*#__PURE__*/React.createElement(ScreenElement, {
    placeholderProps: {
      className: styles.placeholder
    },
    emptyLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "yMpGIc",
      defaultMessage: [{
        "type": 0,
        "value": "Article"
      }]
    }),
    emptyClassName: styles.empty,
    isEmpty: !hasUrl || !hasArticle
  }, !isPlaceholder && hasArticle ? /*#__PURE__*/React.createElement(animated.div, {
    className: styles.card,
    style: {
      height: height,
      width: width,
      transform: !isPreview ? springStyle.y.to(function (value) {
        return "translateY(".concat(value, "%");
      }) : "translateY(".concat(100 - minimumVisibility, "%)")
    }
  }, /*#__PURE__*/React.createElement("button", Object.assign({
    type: "button",
    onClick: toggleCard,
    className: styles.dragHandle,
    tabIndex: !current ? -1 : 0,
    "aria-label": intl.formatMessage({
      id: "IoMJgw",
      defaultMessage: [{
        "type": 0,
        "value": "Toggle article"
      }]
    }),
    "aria-pressed": webviewOpened
  }, current ? bindGesture() : null)), /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.cardInner, _defineProperty({}, styles.pulse, withCardBounce)])
  }, hasCta ? /*#__PURE__*/React.createElement("div", {
    className: styles.callToAction
  }, /*#__PURE__*/React.createElement(Arrow, {
    strokeWidth: 1,
    className: styles.arrow
  }), /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles.ctaText
  }, callToAction))) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.articlePreview,
    ref: articlePreviewRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.articlePreviewInner,
    style: {
      paddingBottom: current && !isPreview ? Math.max(viewerBottomHeight, 20) : null
    }
  }, hasTitle ? /*#__PURE__*/React.createElement(Heading, Object.assign({
    className: classNames([styles.articleTitle])
  }, title)) : null, hasAuthorName ? /*#__PURE__*/React.createElement(UrbaniaAuthor, {
    isSmall: true,
    withoutBackground: true,
    author: author,
    shouldLoad: mediaShouldLoad
  }) : null)))) : null))));
};
UrbaniaArticleCard.defaultProps = defaultProps;
UrbaniaArticleCard.propTypes = propTypes;

/* eslint-disable react/jsx-props-no-spreading */
function UrbaniaCardLoader(props) {
  var _ref = props || {},
    _ref$cardCallToAction = _ref.cardCallToAction,
    cardCallToAction = _ref$cardCallToAction === void 0 ? {} : _ref$cardCallToAction;
  return /*#__PURE__*/React.createElement(UrbaniaLoader, Object.assign({
    component: UrbaniaArticleCard,
    callToAction: cardCallToAction
  }, props));
}

var definitionCard = {
  id: 'urbania-article-card',
  type: 'screen',
  namespaces: ['urbania'],
  group: {
    label: defineMessage({
      id: "oPjl8f",
      defaultMessage: [{
        "type": 0,
        "value": "Urbania"
      }]
    }),
    order: 10
  },
  title: defineMessage({
    id: "nJgzwC",
    defaultMessage: [{
      "type": 0,
      "value": "Urbania article"
    }]
  }),
  component: UrbaniaCardLoader,
  fields: [{
    name: 'url',
    type: 'url',
    label: defineMessage({
      id: "2pO2Cj",
      defaultMessage: [{
        "type": 0,
        "value": "Url"
      }]
    })
  }, {
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "N25iDO",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'author',
    type: 'author-element',
    label: defineMessage({
      id: "73hxYw",
      defaultMessage: [{
        "type": 0,
        "value": "Author"
      }]
    })
  }, {
    name: 'text',
    type: 'text-element',
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "4E2gbX",
      defaultMessage: [{
        "type": 0,
        "value": "Text"
      }]
    })
  }, {
    name: 'background',
    type: 'background',
    label: defineMessage({
      id: "+MPZRu",
      defaultMessage: [{
        "type": 0,
        "value": "Background"
      }]
    })
  }, {
    name: 'cardCallToAction',
    type: 'text-element',
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "eBFxNl",
      defaultMessage: [{
        "type": 0,
        "value": "Call to Action"
      }]
    })
  }, {
    name: 'header',
    type: 'header',
    label: defineMessage({
      id: "rhuDxI",
      defaultMessage: [{
        "type": 0,
        "value": "Header"
      }]
    }),
    theme: {
      badge: {
        label: {
          textStyle: 'badge'
        },
        boxStyle: 'badge'
      }
    }
  }]
};

export { UrbaniaLoader as UrbaniaArticle, UrbaniaCardLoader as UrbaniaArticleCard, UrbaniaArticle as UrbaniaBaseArticle, UrbaniaArticleCard as UrbaniaBaseArticleCard, definition as default, definitionCard };
